<template>
  <section class="accordion-block" :class="brandClasses">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <sc-text
            v-if="fields.title"
            :field="fields.title"
            class="accordion-block__title font-l"
            tag="h2"
          />
          <ul class="accordion-block__list">
            <sc-placeholder name="accordion-block-placeholder" :rendering="rendering" />
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Placeholder as ScPlaceholder, Text as ScText } from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';
import { useJssStore } from '../../stores/jssStore';
import type { AccordionBlockProps } from './types';

const props = withDefaults(defineProps<AccordionBlockProps>(), {
  fields: () => ({}),
  params: () => ({}),
});

const jssStore = useJssStore();

const brandClasses = computed(() => [
  jssStore.brandName === 'ChefBrewer' && 'bottom-green-border top-green-border',
  jssStore.brandName === 'Belhaven' && 'blh-in-grid',
]);
</script>

<style lang="scss">
@import './scss/AccordionBlock.scss';
</style>
